var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[(_vm.top)?_c('div',{staticClass:"top"},[_vm._v(_vm._s(_vm.top))]):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }